import { IMPERSONATE_STORAGE_KEY, ROWI_API_GATEWAY_PREFIX } from 'config';
export function readImpersonateFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return (params.get('impersonate_email') || '').trim();
}
export function readStickyImpersonateEmail() {
    return (localStorage.getItem(IMPERSONATE_STORAGE_KEY) || '').trim();
}
export function persistStickyImpersonateEmail(email) {
    if (email) {
        localStorage.setItem(IMPERSONATE_STORAGE_KEY, email);
    }
    else {
        localStorage.removeItem(IMPERSONATE_STORAGE_KEY);
    }
}
export function writeImpersonateToBrowserUrl(email) {
    const current = new URL(window.location.href);
    if (email) {
        current.searchParams.set('impersonate_email', email);
    }
    else {
        current.searchParams.delete('impersonate_email');
    }
    history.replaceState({}, document.title, current.toString());
}
/**
 * The impersonation email the user is asking for right now: an explicit URL param wins
 * over the sticky localStorage value. Safe to call before installImpersonation() — used
 * by the auth exchange adapter, which runs during bootstrap.
 */
export function resolveRequestedImpersonateEmail() {
    return readImpersonateFromUrl() || readStickyImpersonateEmail();
}
export function appendImpersonateQuery(url, impersonateEmail) {
    if (!impersonateEmail)
        return url;
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('impersonate_email', impersonateEmail);
    return parsed.toString();
}
export function appendImpersonationForRowiApi(url, impersonateEmail) {
    if (!url.startsWith(ROWI_API_GATEWAY_PREFIX))
        return url;
    return appendImpersonateQuery(url, impersonateEmail);
}
